module.exports = __webpack_public_path__ + "static/images/components/VehicleType/images/lightTank-prem.0b5d94c6.png";


//////////////////
// WEBPACK FOOTER
// ./components/VehicleType/images/lightTank-prem.png
// module id = 2722
// module chunks = 11